import { useState } from "react";
import styled from "styled-components";
import { Spacer } from "./Spacer";
import { ModalDS } from "./Modal";

export interface PictureViewerDSProps {
  url: string;
  bottomContent?: JSX.Element;
}

export const PictureViewerDS = (props: PictureViewerDSProps) => {
  const [zoomed, setZoomed] = useState<boolean>(false);

  return (
    <StyledThumbnail>
      <StyledImg src={props.url} alt="" onClick={() => setZoomed(true)} />
      <ModalDS visible={zoomed} onClose={() => setZoomed(false)} width={50}>
        <StyledZoom>
          <Spacer y={1} />
          <StyledZoomImg src={props.url} alt="" />
          {props.bottomContent && (
            <>
              <Spacer y={1} />
              {props.bottomContent}
            </>
          )}
        </StyledZoom>
      </ModalDS>
    </StyledThumbnail>
  );
};

const StyledThumbnail = styled.div`
  position: relative;
  aspect-ratio: 1;
`;

const StyledImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
  cursor: pointer;
`;

const StyledZoom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledZoomImg = styled.img`
  max-width: 100%;
  max-height: 70vh;
`;
